export function isIOS() {
  return navigator.userAgent.match(/ipad|iphone/i)
}